// src/api/index.js - 完整版
import request from '../utils/request';

// 认证相关
export const authApi = {
  login: (data) => request.post('/api/auth/login', data),
  getCurrentUser: () => request.get('/api/auth/me'),
  changePassword: (data) => request.post('/api/auth/change-password', data)
};

// 商品相关
export const productApi = {
  getList: (params) => request.get('/api/products', { params }),
  getDetail: (id) => request.get(`/api/products/${id}`),
  create: (data) => request.post('/api/products', data),
  update: (id, data) => request.put(`/api/products/${id}`, data),
  delete: (id) => request.delete(`/api/products/${id}`),
  getLowStock: () => request.get('/api/products/low-stock/list'),
  getHQStock: () => request.get('/api/products/hq-stock') 
};

// 销售相关
export const saleApi = {
  create: (data) => request.post('/api/sales', data),
  getList: (params) => request.get('/api/sales', { params }),
  getDetail: (id) => request.get(`/api/sales/${id}`),
  getPending: () => request.get('/api/sales/pending/list'),
  confirm: (order_no) => request.post(`/api/sales/${order_no}/confirm`),
  cancelSale: (order_no) => request.post(`/api/sales/${order_no}/cancel`),
};

// 班次相关
export const shiftApi = {
  start: (data) => request.post('/api/shifts/start', data),
  end: (data) => request.post('/api/shifts/end', data),
  getCurrent: () => request.get('/api/shifts/current'),
  getHistory: (params) => request.get('/api/shifts/history', { params }),
  getDetail: (id) => request.get(`/api/shifts/${id}`)
};

// 报表相关
export const reportApi = {
  getTodayOverview: () => request.get('/api/reports/today-overview'),
  getSalesStatistics: (params) => request.get('/api/reports/sales-statistics', { params }),
  getTopProducts: (params) => request.get('/api/reports/top-products', { params }),
  getStaffPerformance: (params) => request.get('/api/reports/staff-performance', { params }),
  getSalesReport: (params) => request.get('/api/reports/sales-report', { params }), // 加这行
};

// 用户管理
export const userApi = {
  getList: (params) => request.get('/api/users', { params }),
  create: (data) => request.post('/api/users', data),
  update: (id, data) => request.put(`/api/users/${id}`, data),
  resetPassword: (id, data) => request.post(`/api/users/${id}/reset-password`, data)
};

// 库存管理
export const inventoryApi = {
  adjust: (data) => request.post('/api/products/inventory/adjust', data),
  batchAdjust: (data) => request.post('/api/products/inventory/batch-adjust', data),
  getLogs: (params) => request.get('/api/products/inventory/logs', { params }),
  getProductLogs: (id) => request.get(`/api/products/${id}/inventory/logs`)
};

// 分类管理
export const categoryApi = {
  getList: () => request.get('/api/categories'),
  getDetail: (id) => request.get(`/api/categories/${id}`),
  create: (data) => request.post('/api/categories', data),
  update: (id, data) => request.put(`/api/categories/${id}`, data),
  delete: (id) => request.delete(`/api/categories/${id}`),
  getStats: () => request.get('/api/categories/stats/overview')
};

// 单位管理 ← 新增这部分
export const unitApi = {
  getList: (params) => request.get('/api/units', { params }),
  getDetail: (id) => request.get(`/api/units/${id}`),
  getStats: () => request.get('/api/units/stats/overview'),
  create: (data) => request.post('/api/units', data),
  update: (id, data) => request.put(`/api/units/${id}`, data),
  delete: (id) => request.delete(`/api/units/${id}`)
};

// 上传管理 ← 也可以加上图片上传 API
// 在你的 src/api/index.js 中,确保 uploadApi 是这样的:

// 上传管理
export const uploadApi = {
  uploadProductImage: async (file) => {
    console.log('🔵 uploadApi.uploadProductImage 被调用');
    console.log('📦 接收到的文件:', {
      name: file.name,
      size: file.size,
      type: file.type,
      lastModified: file.lastModified
    });
    
    const formData = new FormData();
    formData.append('image', file);
    
    console.log('📤 准备发送 FormData');
    console.log('🌐 请求 URL: /api/upload/product-image');
    
    try {
      const response = await request.post('/api/upload/product-image', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      
      console.log('✅ 上传响应成功:', response);
      return response;
      
    } catch (error) {
      console.error('❌ 上传请求失败:', error);
      console.error('❌ 错误详情:', {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status,
        config: error.config
      });
      throw error;
    }
  },
  
  deleteProductImage: (filename) => {
    console.log('🗑️ deleteProductImage 被调用:', filename);
    return request.delete('/api/upload/product-image', { 
      data: { filename } 
    });
  }
};

// 门店管理
export const storeApi = {
  getList: () => request.get('/api/stores'),
  getDetail: (id) => request.get(`/api/stores/${id}`),
  create: (data) => request.post('/api/stores', data),
  update: (id, data) => request.put(`/api/stores/${id}`, data),
  getSummary: (params) => request.get('/api/stores/summary', { params })
};

// 库存划拨
export const stockTransferApi = {
  getList: (params) => request.get('/api/stock-transfers', { params }),
  getDetail: (transfer_no) => request.get(`/api/stock-transfers/${transfer_no}`),
  create: (data) => request.post('/api/stock-transfers', data),
  ship: (transfer_no) => request.put(`/api/stock-transfers/${transfer_no}/ship`),
  receive: (transfer_no, data) => request.put(`/api/stock-transfers/${transfer_no}/receive`, data),
  pay: (transfer_no, data) => request.put(`/api/stock-transfers/${transfer_no}/pay`, data),
  confirmPayment: (transfer_no) => request.put(`/api/stock-transfers/${transfer_no}/confirm-payment`),
  cancel: (transfer_no) => request.put(`/api/stock-transfers/${transfer_no}/cancel`),
  edit: (transfer_no, data) => request.put(`/api/stock-transfers/${transfer_no}/edit`, data),
  getLogs: (transfer_no) => request.get(`/api/stock-transfers/${transfer_no}/logs`),
};
// 订单管理（H5订单）
export const ordersManageApi = {
  getList: (params) => request.get('/api/orders', { params }),
  getDetail: (id) => request.get(`/api/orders/${id}`),
  assign: (id, data) => request.put(`/api/orders/${id}/assign`, data),
  confirm: (id) => request.put(`/api/orders/${id}/confirm`),
  prepare: (id) => request.put(`/api/orders/${id}/prepare`),
  deliver: (id) => request.put(`/api/orders/${id}/deliver`),
  complete: (id) => request.put(`/api/orders/${id}/complete`),
  getSettlements: (params) => request.get('/api/orders/settlements', { params })
};

export const shopSettingsApi = {
  getPublicSettings: () => request.get('/api/shop-settings/public'),
  getSettings: () => request.get('/api/shop-settings'),
  updateSettings: (data) => request.put('/api/shop-settings', data),
  getBanners: () => request.get('/api/shop-settings/banners'),
  createBanner: (data) => request.post('/api/shop-settings/banners', data),
  updateBanner: (id, data) => request.put(`/api/shop-settings/banners/${id}`, data),
  deleteBanner: (id) => request.delete(`/api/shop-settings/banners/${id}`)
};

export const customerApi = {
  getList: (params) => request.get('/api/customers', { params }),
  getDetail: (id) => request.get(`/api/customers/${id}`),
  setVip: (id, data) => request.put(`/api/customers/${id}/vip`, data),
  setSuperVip: (id, data) => request.put(`/api/customers/${id}/super-vip`, data),
  getCommissionLogs: (id, params) => request.get(`/api/customers/${id}/commission-logs`, { params }),
  getBalance: (id, params) => request.get(`/api/customers/${id}/balance`, { params }),
  adjustBalance: (id, data) => request.post(`/api/customers/${id}/balance/adjust`, data),
};
// KHQR 支付
export const khqrApi = {
  create: (data) => request.post('/api/khqr/create', data),
  check: (data) => request.post('/api/khqr/check', data),
};

export const vpnApi = {
  // 链接池
  getPoolList: (params) => request.get('/api/vpn/pool', { params }),
  createPool: (data) => request.post('/api/vpn/pool', data),
  updatePool: (id, data) => request.put(`/api/vpn/pool/${id}`, data),
  deletePool: (id) => request.delete(`/api/vpn/pool/${id}`),
  // 客户订阅
  getCustomerSubscriptions: (customer_id) => request.get(`/api/vpn/subscriptions/${customer_id}`),
  assignToCustomer: (data) => request.post('/api/vpn/assign', data),
  unassignFromCustomer: (pool_id) => request.put(`/api/vpn/unassign/${pool_id}`),
};

